import styled from 'styled-components';
import { BKJIcon } from '../BKJIcon/index.js';
export const BKJDialogWrapper = styled.div `
  width: 100%;
  max-width: 624px;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background: #ffffff;

  box-shadow: 0px 2px 8px rgba(13, 51, 32, 0.3);
  border-radius: 8px;

  ${({ theme, variant }) => theme.dialog[variant]}
`;
export const CloseIconWrapper = styled.div `
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 12px;
  right: 12px;
  padding: 12px;
  cursor: pointer;
  &:focus-visible {
    outline-color: ${({ theme }) => theme.colors.TextSubtleGrey};
    outline-style: solid;
  }
`;
export const CloseIcon = styled(BKJIcon) ``;
export const TextWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding-top: 36px;
  padding-left: 48px;
  padding-right: 48px;
  padding-bottom: 12px;
`;
export const Title = styled.div `
  ${({ theme }) => theme.fonts.PoppinsBold};
  font-size: 28px;
  line-height: 34px;
  text-align: center;
`;
export const Text = styled.div `
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  line-height: 22px;
  text-align: center;
`;
export const ButtonGroup = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 0.5px solid ${({ theme }) => theme.colors.GreyDivider};
  padding: 0 24px;
  height: 80px;
  min-height: 80px;
  max-height: 80px;
  gap: 8px;
`;
//# sourceMappingURL=BKJDialog.styled.js.map